import type { TypeTextColorVariant } from '@/components/types';
import type { FunctionComponent } from 'react';
import type { TypeCaptionProps } from './types';

const CaptionLeftSvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.16101 3.69658C7.18749 3.69658 7.20074 3.65686 7.18138 3.65177C6.64052 3.45518 5.80835 2.68616 5.3011 1.84074C4.80709 0.908747 4.49337 -0.0140797 3.92806 0.215099C3.30978 0.491133 3.59906 1.96195 4.38744 2.6831C5.09942 3.3136 6.46533 3.70371 7.16101 3.69658Z" />
    <path d="M5.4763 4.02865L5.47732 4.00522C4.23262 3.58964 3.30062 3.3299 2.2464 3.23314C0.599368 3.21582 0.544364 3.78826 0.50464 3.95633C0.464916 4.12439 0.603442 4.72739 1.99074 4.76813C3.37804 4.80887 5.4763 4.02865 5.4763 4.02865Z" />
    <path d="M5.13505 6.19104C5.66879 5.36396 6.52031 4.61633 7.06525 4.434C7.0897 4.42586 7.07238 4.39021 7.04692 4.38919C6.34919 4.36372 4.97718 4.71309 4.24584 5.33035C3.42996 6.03011 3.10606 7.48871 3.71618 7.779C4.2764 8.02346 4.61864 7.10674 5.13505 6.19104Z" />
  </svg>
);
const CaptionRightSvg = (
  <svg
    className="ml-2"
    width="24"
    height="24"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.83866 4.30218C0.812177 4.30218 0.798935 4.3419 0.818288 4.347C1.35915 4.54358 2.19133 5.3126 2.69858 6.15802C3.19258 7.09002 3.5063 8.01284 4.07161 7.78366C4.68989 7.50763 4.40061 6.03681 3.61224 5.31566C2.90025 4.68516 1.53435 4.29505 0.83866 4.30218Z" />
    <path d="M2.52337 3.97012L2.52236 3.99354C3.76705 4.40912 4.69905 4.66886 5.75327 4.76562C7.4003 4.78294 7.45531 4.2105 7.49503 4.04244C7.53476 3.87437 7.39623 3.27138 6.00893 3.23063C4.62164 3.18989 2.52337 3.97012 2.52337 3.97012Z" />
    <path d="M2.86462 1.80772C2.33088 2.6348 1.47936 3.38243 0.93442 3.56476C0.909974 3.57291 0.927291 3.60856 0.952755 3.60957C1.65048 3.63504 3.0225 3.28567 3.75383 2.66841C4.56971 1.96865 4.89362 0.510055 4.28349 0.219762C3.72328 -0.0246961 3.38103 0.89202 2.86462 1.80772Z" />
  </svg>
);

const VARIANT_MAPS: Record<TypeTextColorVariant, string> = {
  primary: 'text-primary fill-primary-400',
  primaryLight: 'text-primary-light fill-primary-300',
  secondary: 'text-secondary fill-secondary-400',
  tertiary: 'text-black fill-black',
  alternative: 'text-white fill-white',
};
const domain = process.env.NEXT_PUBLIC_DOMAIN;

/**
 * Caption
 */
export const Caption: FunctionComponent<TypeCaptionProps> = ({
  className = '',
  variant = 'primary',
  mobileAlignment = 'start',
  children,
  align = 'start',
  hasDecoration = true,
}: TypeCaptionProps) => (
  <div
    className={`inline-flex w-full flex-row items-center ${
      VARIANT_MAPS[variant]
    } ${
      align === 'start'
        ? 'md:justify-start'
        : align === 'center'
        ? 'md:justify-center'
        : 'md:justify-end'
    } ${
      mobileAlignment === 'start'
        ? 'justify-start'
        : mobileAlignment === 'center'
        ? 'justify-center'
        : 'justify-end'
    }`}
  >
    {domain === 'apartments' && hasDecoration ? (
      <div className="flex">
        {CaptionLeftSvg}
        <p
          className={`text-caption text-caption--small items-center justify-center uppercase lg:text-caption--large ${className}`}
        >
          {children}
        </p>
        {CaptionRightSvg}
      </div>
    ) : (
      <p
        className={`text-caption text-caption--small items-center justify-center uppercase lg:text-caption--large ${className}`}
      >
        {children}
      </p>
    )}
  </div>
);

Caption.displayName = 'Caption';
